import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/consultations/test-tube-1.svg'
import _imports_1 from '@/assets/images/consultations/pharma.svg'
import _imports_2 from '@/assets/images/menuIcons/creditcard.svg'


const _hoisted_1 = { class: "w-full mtop-02 mleft-10" }
const _hoisted_2 = { style: {"margin-top":"0.3rem"} }
const _hoisted_3 = { class: "row w-full" }
const _hoisted_4 = { class: "item-modal" }
const _hoisted_5 = {
  key: 1,
  class: "rowend w-full gap-08 mright-32px"
}
const _hoisted_6 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem"}
}
const _hoisted_7 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem"}
}
const _hoisted_8 = {
  class: "row gap-10 w-full mleft-05 left-column",
  style: {"margin-top":"-0.5rem"}
}

import patientActions from "./patientActions.vue"
import editTask from '@/views/officeMain/tasks/editTask.vue';

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { apiDateString } from "@/api/apicommon";
import patientapi from '@/api/patientapi';
import { useUiStore } from '@/stores/ui';
import { formatMatricule } from '@/functions/lu';
import { PersonWithRoleStatus } from '@/models/share.model';
import { FinancialGroupLightResponse } from '@/apiGenerate/medserver';
import { storeToRefs } from 'pinia'
import { useFinancialGroupsStore } from '@/stores/financialGroups'
import { NoteGroup, getGenderIcon } from '@/functions/office';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'lBarUpperMenu',
  emits: ['openAdmin'],
  setup(__props, { emit: __emit }) {

const financialGroupsStore = useFinancialGroupsStore();
const { allFinancialGroups } = storeToRefs(financialGroupsStore);

const doctor = ref<boolean>(false);

const { t } = useI18n();
const dropd = ref();
const currentEntryStore = useCurrentEntryStore();
const uiStore = useUiStore();

const emits = __emit;

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
});

const patientName = computed(() => {
  if (!currentEntryStore.currentPatient) return "";
  const pwr = currentEntryStore.currentPatient;
  return PersonService.formatName(pwr.lastName, pwr.firstName);
})

const age = computed(() => {
  if (!currentEntryStore.currentPatient) return "";
  return currentEntryStore.currentPatient.ageTerm;
})

const birthDate = computed(() => {
  if (!currentEntryStore.currentPatient) return "";
  const cnsHealthInsurance = currentEntryStore.currentPatient.cnsHealthInsurance?.cnsAffiliationNumber;
  if (!cnsHealthInsurance && currentEntryStore.currentPatient.nonCnsSsn) return currentEntryStore.currentPatient.nonCnsSsn;
  if (cnsHealthInsurance) return formatMatricule(cnsHealthInsurance);
  return apiDateString(currentEntryStore.currentPatient.birthDate);
})

const notesToShow = computed(() => {
  if (!currentEntryStore.currentPatientNotes) return [];
  const notesGroup = currentEntryStore.currentPatientNotes.find(
    (item) => item.keyword === NoteGroup.NOTES
  );
  if (!notesGroup?.tasks) return [];
  return notesGroup.tasks.filter((task) =>
    ["DuringShift", "EndOfShift"].includes(task.taskPriorityType)
  );
});

async function createTemplate(internalCode: string, originalText: string, financialGroupId: string | null) {
  uiStore.clearDashBoard()
  const existingTemplateDoc = getExistingTemplateDoc(internalCode)
  if (existingTemplateDoc) {
    await openExistingPatientDoc(existingTemplateDoc.patientDocumentId)
  } else {
    currentEntryStore.setMiddleTab('docTemplate')
    currentEntryStore.emptyCurrentDoc()
    const newDoc = await patientapi.addOfficialTemplateToCclZero(
      internalCode, originalText, "", "None", currentEntryStore.currentEntryId, financialGroupId
    )
    currentEntryStore.setCurrentDoc(newDoc)
    currentEntryStore.reloadCurrentEntry()
  }
}

async function openExistingPatientDoc(patientDocumentId: string) {
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const fullDoc = await patientapi.getPatientDocument(
    patientDocumentId,
    currentEntryStore.currentEntryId
  )
  currentEntryStore.setCurrentDoc(fullDoc)
  currentEntryStore.reloadCurrentEntry()
}

async function openExistingBill() {
  if (existingBillDoc.value) {
    uiStore.clearDashBoard();
    await openExistingPatientDoc(existingBillDoc.value.patientDocumentId);
    return;
  } else if (allFinancialGroups.value.length === 1) {
    createBill(allFinancialGroups.value[0]);
  }
}

function getExistingTemplateDoc(internalCode: string) {
  return currentEntryStore.allPatientDocuments.find(
    doc => doc.templateStatus === 'Template' && doc.documentGroup.internalCode === internalCode
  )
}

function createReport() {
  dropd.value = "";
  createTemplate("Report", t('patient.header.report'), null);
}

function createReportWithHistory() {
  dropd.value = "";
  createTemplate("ReportWithHistory", t('patient.header.reportWithHistoryShort'), null);
}

function createOperativeReport() {
  dropd.value = "";
  createTemplate("OperativeReport", t('patient.header.operativeReport'), null);
}

function prescribePharmacy() {
  createTemplate("MedicRequest", "Pharmacie", null)
}

function prescribeBio() {
  currentEntryStore.clearCurrExpr_Ccl();
  createTemplate("BioRequest", "Bio", null)
}

function createBill(financialGroup: FinancialGroupLightResponse) {
  dropd.value = "";
  createTemplate("Bill", "MH", financialGroup.id.toString());
}

const existingBillDoc = computed(() => getExistingTemplateDoc('Bill'))

const mainLanguage = computed(() =>
  currentEntryStore.currentPatient?.languages?.[0]?.languageIso ?? ""
);

const sex = computed(() => {
  return getGenderIcon(currentEntryStore.currentPatient);
})

function reload() {
  currentEntryStore.reloadModalPatientNotes(currentEntryStore.currentPatientId);
}

function openTaskModal() {
  uiStore.setModalUiId('addTaskNoteFromPatientFile')
}

watch(
  () => currentEntryStore._currentEntry?.healthPro,
  () => {
    doctor.value = PersonWithRoleStatus.HealthPro == currentEntryStore.currentHealthPro?.personRoleType;
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_listGroup = _resolveComponent("listGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "row cursor-action hover-wrapper gap-08",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openAdmin')))
          }, [
            _createVNode(_component_text_item, {
              txt: patientName.value,
              styles: "font-lBold"
            }, null, 8, ["txt"]),
            _createVNode(_component_text_item, {
              txt: age.value,
              styles: "font-lBold",
              class: "patient-age"
            }, null, 8, ["txt"]),
            _createVNode(_component_text_item, {
              txt: sex.value,
              styles: "font-lBold"
            }, null, 8, ["txt"]),
            (mainLanguage.value)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 0,
                  txt: mainLanguage.value,
                  styles: "font-lBold",
                  class: "patient-lang"
                }, null, 8, ["txt"]))
              : _createCommentVNode("", true),
            _createVNode(_component_text_item, {
              txt: birthDate.value,
              styles: "font-lBold",
              class: "patient-birthdate"
            }, null, 8, ["txt"])
          ]),
          (_unref(currentEntryStore).currentPatient)
            ? (_openBlock(), _createBlock(_component_dropdownBox, {
                key: 0,
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dropd).value = $event)),
                openOn: "patientActions"
              }, {
                dropd: _withCtx(() => [
                  _createVNode(patientActions, {
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (dropd.value = '')),
                    onAddTask: openTaskModal
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_item, {
                        icon: "moreVertical",
                        styles: "main-l size-l"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_itemModal, { uiId: "addTaskNoteFromPatientFile" }, {
            modal: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(editTask, {
                  pwrPatient: _unref(currentEntryStore).currentPatient,
                  canChangePatient: false,
                  onChanged: _cache[3] || (_cache[3] = ($event: any) => (reload()))
                }, null, 8, ["pwrPatient"])
              ])
            ]),
            _: 1
          }),
          (isEditable.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
                  openOn: "OpenNewReport"
                }, {
                  dropd: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_dbGroup, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_list_group, {
                            class: "w-full",
                            styles: "pad-m",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (createReport()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "fileText",
                                styles: "size-s",
                                style: {"margin-top":"-0.5rem"},
                                class: ""
                              }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('patient.header.report'),
                                class: "mleft-05 font-size-14"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_list_group, {
                            class: "w-full",
                            styles: "pad-m",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (createReportWithHistory()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "fileText",
                                styles: "size-s",
                                style: {"margin-top":"-0.5rem"},
                                class: ""
                              }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('patient.header.reportWithHistory'),
                                class: "mleft-05 font-size-14"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_list_group, {
                            class: "w-full",
                            styles: "pad-m",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (createOperativeReport()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_item, {
                                icon: "fileText",
                                styles: "size-s",
                                style: {"margin-top":"-0.5rem"},
                                class: ""
                              }),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('patient.header.operativeReport'),
                                class: "mleft-05 font-size-14"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, { class: "align-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          icon: "fileText",
                          styles: "size-s",
                          style: {"margin-top":"-0.5rem"},
                          class: "img-primary"
                        }),
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.header.report'),
                          class: "mleft-05 txt-primary font-size-14"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_buttonGroup, {
                  class: "align-center",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (prescribeBio()))
                }, {
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "img-primary"
                    }, null, -1)),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.header.lab'),
                      class: "mleft-05 txt-primary font-size-14"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_buttonGroup, {
                  class: "align-center",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (prescribePharmacy()))
                }, {
                  default: _withCtx(() => [
                    _cache[13] || (_cache[13] = _createElementVNode("img", {
                      src: _imports_1,
                      class: "img-primary"
                    }, null, -1)),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.header.pharma'),
                      class: "mleft-05 txt-primary font-size-14"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }),
                (doctor.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (existingBillDoc.value || _unref(allFinancialGroups).length == 1)
                        ? (_openBlock(), _createBlock(_component_buttonGroup, {
                            key: 0,
                            class: "align-center",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (openExistingBill()))
                          }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createElementVNode("img", {
                                src: _imports_2,
                                class: "img-primary"
                              }, null, -1)),
                              _createVNode(_component_text_item, {
                                txt: _unref(t)('patient.header.billing'),
                                class: "mleft-05 txt-primary font-size-14"
                              }, null, 8, ["txt"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_dropdownBox, {
                            key: 1,
                            modelValue: dropd.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dropd).value = $event)),
                            openOn: "CreateBill"
                          }, {
                            dropd: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                (_unref(allFinancialGroups).length)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(allFinancialGroups), (financialGroup) => {
                                      return (_openBlock(), _createBlock(_component_listGroup, {
                                        key: financialGroup.id,
                                        styles: "pad-s",
                                        onClick: ($event: any) => (createBill(financialGroup))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            class: "psides-06 txt-primary",
                                            txt: financialGroup.title
                                          }, null, 8, ["txt"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  : (_openBlock(), _createBlock(_component_text_item, {
                                      key: 1,
                                      class: "main-l psides-06",
                                      txt: "Pas de groupe financier"
                                    }))
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_buttonGroup, { class: "align-center" }, {
                                default: _withCtx(() => [
                                  _cache[15] || (_cache[15] = _createElementVNode("img", {
                                    src: _imports_2,
                                    class: "img-primary"
                                  }, null, -1)),
                                  _createVNode(_component_text_item, {
                                    txt: _unref(t)('patient.header.billing'),
                                    class: "mleft-05 txt-primary font-size-14"
                                  }, null, 8, ["txt"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]))
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notesToShow.value, (task, index) => {
            return (_openBlock(), _createBlock(_component_text_item, {
              key: index,
              txt: task.taskNotes[0].noteContent,
              styles: task.taskPriorityType === 'DuringShift' ? 'main-alert' : 'main-m'
            }, null, 8, ["txt", "styles"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})